var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-cursor":""}},[_c('div',{staticClass:"cur1"},[_c('span',{staticClass:"see"},[_vm._v("See")])]),_c('div',{staticClass:"cur2"})])}]

export { render, staticRenderFns }